import React from "react";
import { Link } from 'react-router-dom'
import { useQuery } from "@tanstack/react-query";
import { getHomeTestimonialAPI } from "./APIS";
import parse from "html-react-parser";

function TestimonialHome() {
  const { isLoading, error, data } = useQuery({
    queryKey: ["testimonials"],
    queryFn: getHomeTestimonialAPI,
  });

  if (error) return <div>{error.message}</div>;
  return (
<div className="testimonial-home-wrap"><span id="testimonial-home" style={{position:"relative", top:"-150px", display:"inline-block" }}></span>
  <div className="left-testi-home">#chaashnilove </div>
  <div className="right-testi-home">
          {isLoading && (
            <></>
          )}


{data?.testimonials.profile_image&&(<div className="right-testi-img"> 
<img src={`${process.env.REACT_APP_IMAGE_URL}testimonial_profile/${data?.testimonials.profile_image}`} className="attachment-66x93 size-66x93 wp-post-image" style={{borderRadius:"50%"}} alt={data?.testimonials.name} width="66px" height="96px" loading="lazy" /></div>)}


    <div className="right-testi-text"><div className="right-testi-text-box">{data?.testimonials && parse(data?.testimonials?.description)}</div>   
      <div className="testi-author-name"> <span className="testiname"><strong>- {data?.testimonials.name}</strong></span> {/* <span className="testi-link">
        <Link to="https://www.instagram.com/sujata.goel/" target="_blank">
        https://www.instagram.com/sujata.goel/
        </Link>
        </span> */} </div>
    </div>

         {/*  {testimonials && testimonials.map((e, i) => (
            <> </>
          ))} */}
     </div>
</div>
  );
}

export default TestimonialHome;
